// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__hJhNv","flow":"styles_flow__kDK8r","flowContent":"styles_flowContent__jZ5Ap"};